module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('figure', {
    staticClass: "person-icon"
  }, [(_vm.attendee.pictureUrl) ? _c('img', {
    attrs: {
      "src": _vm.attendee.pictureUrl,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    },
    on: {
      "click": _vm.openPersonCard
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/icons/anonymous.svg")
    },
    on: {
      "click": _vm.openPersonCard
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.attendee.firstName) + " " + _vm._s(_vm.attendee.lastName))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71bca954","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonIcon.vue
// module id = 479
// module chunks = 0